export default __webpack_public_path__ + "static/media/discord_white.6f9e84a8.svg";